module.exports = __webpack_public_path__ + "img/9788994077796.db499e42.jpg";